import { render, staticRenderFns } from "./ButtonTelephoneCall.vue?vue&type=template&id=67aafa32"
import script from "./ButtonTelephoneCall.vue?vue&type=script&lang=js"
export * from "./ButtonTelephoneCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsPhone: require('/home/forge/ab.farescraper.com/components/IconsPhone.vue').default})
